export default "__VITE_ASSET__BJyQPdqT__"